const INDEX_ITEMS = [
  { label: '港片经典合集', count: 218, letter: '港' },
  { label: '好莱坞动作大片', count: 165, letter: '动' },
  { label: '日漫热血番', count: 142, letter: '漫' },
  { label: '国产高分剧集', count: 198, letter: '剧' },
  { label: '悬疑推理专区', count: 87, letter: '悬' },
  { label: '喜剧片大全', count: 134, letter: '喜' },
  { label: '科幻视觉盛宴', count: 96, letter: '科' },
  { label: '4K蓝光专区', count: 256, letter: '4K' },
  { label: '纪录片精选', count: 73, letter: '纪' },
];

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">专题索引</h2>
            <p className="mt-2 text-sm text-foreground-500">按主题快速定位，找到你感兴趣的影视专题</p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-9 gap-3">
            {INDEX_ITEMS.map((item, i) => (
              <a
                key={i}
                href="#cards"
                className="group flex flex-col items-center p-4 rounded-xl bg-background-100 border border-background-200/60 hover:border-primary-300/40 transition-all duration-300 cursor-pointer"
              >
                <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center group-hover:bg-primary-200 transition-colors">
                  <span className="font-heading text-sm font-bold text-primary-600">{item.letter}</span>
                </div>
                <h3 className="mt-3 text-xs font-medium text-foreground-800 text-center line-clamp-1">{item.label}</h3>
                <span className="mt-1.5 text-xs text-foreground-400">{item.count} 部</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}